<script lang="ts">
  import type { SalesRep } from "@shared/types/SalesRep";
  import Authorization from "@shared/svelte/Components/Authorization.svelte";
  import Autocomplete from "@shared/svelte/Components/Autocomplete.svelte";
  import type { RetailerIndexType } from "@shared/types/Retailer";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2.js";

  export let salesRep: SalesRep;
  let retailerToAdd: RetailerIndexType;

  const addRetailerAccount = async () => {
    try {
      await HttpPromise({
        method: "POST",
        url: "/api/distributor/sales_rep_assignments",
        data: {
          retailer_id: retailerToAdd.id,
          sales_rep_id: salesRep.id,
        },
      });
      Flash.now({ type: "success", message: "We have added an account to this sales rep." });
      retailerToAdd = null;
    } catch (_) {
      Flash.now({
        type: "error",
        message: "There was an error in adding the retailer account to this rep.",
      });
    }
  };
</script>

<Authorization authName={"sales_rep_assignments.create"}>
  <Autocomplete
    placeholder={"Search your retailers"}
    objectType={"retailer"}
    searchUrlInput={"/api/distributor/retailers"}
    apiParams={{}}
    bind:value={retailerToAdd}
  />
  <button class="fizz-button-primary" on:click={addRetailerAccount} disabled={!retailerToAdd}
    >Add</button
  >
</Authorization>
